export const registerWebAuthn = (data) => {
  if (!globalThis.PublicKeyCredential?.parseCreationOptionsFromJSON) {
    return Promise.reject(new Error('webauthn_not_supported'))
  }
  const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(
    data.registrationData.credentialCreationOptions,
  )
  return navigator.credentials.create({ publicKey }).then(
    (credential) => {
      if (!credential) return Promise.reject(new Error('no_credential'))
      return Promise.resolve(credential.toJSON())
    },
    (error) =>
      Promise.reject(error instanceof Error ? error : new Error(String(error))),
  )
}
